import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'edit',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'ReservationEdit',
				),
			store,
			'RESERVATION_EDIT',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/User/ReservationRecord/Edit/index.js